'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoKeyboard = function GoKeyboard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 22.5h2.5v-5h-2.5v5z m5-12.5h-2.5v5h2.5v-5z m-5 0h-2.5v5h2.5v-5z m-5 12.5h2.5v-5h-2.5v5z m-5 7.5h12.5v-5h-12.5v5z m15-7.5h5v-12.5h-2.5v7.5h-2.5v5z m-20 7.5h2.5v-5h-2.5v5z m20 0h5v-5h-5v5z m-10-20h-2.5v5h2.5v-5z m-12.5 7.5h-2.5v5h2.5v-5z m0 7.5h-2.5v5h2.5v-5z m-7.5-20v30h40v-30h-40z m37.5 27.5h-35v-25h35v25z m-22.5-10h2.5v-5h-2.5v5z m-5-12.5h-5v5h5v-5z m5 0h-2.5v5h2.5v-5z m-5 12.5h2.5v-5h-2.5v5z' })
        )
    );
};

exports.default = GoKeyboard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/keyboard.js
// module id = 1714
// module chunks = 0